
export default {
  data() {
    return {
      activeIndex: 0,
      image: null,

      options: [
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "title",
          label: "Title",
          type: "text",
        },
        {
          name: "description",
          label: "Description",
          type: "tipTap",
        },
        {
          name: "link",
          label: "Link",
          type: "link",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("item0").click();
    });
  },
  methods: {
    activeItem(item, index) {
      this.activeIndex = index;
      this.image = item.image;
    },
  },
};
